<form [formGroup]="form">
  <div class="rowContainer">
    <div class="rowTitle">{{ 'loading_place' | translate }}</div>
    <div class="selectWrapper">
      <gl-select formControlName="origin" data-ctx="loadingPlaceSelect">
        @for (stop of stops | slice: 0:stops.length - 1; track stop) {
          <gl-option
            [value]="stop"
            [label]="stop.name"
          ></gl-option>
        }
      </gl-select>
      <gl-modal-hint data-ctx="infoHint" class="info">{{ 'loading_place_info' | translate }}</gl-modal-hint>
    </div>
  </div>
  <div class="rowContainer">
    <div class="rowTitle">{{ 'place_of_landing' | translate }}</div>
    <div class="selectWrapper">
      <gl-select formControlName="destination" data-ctx="placeOfLandingSelect">
        @for (stop of destinationStops; track stop) {
          <gl-option
            [value]="stop"
            [label]="stop.name"
          ></gl-option>
        }
      </gl-select>
      <gl-modal-hint class="info">{{ 'place_of_landing_info' | translate }}</gl-modal-hint>
    </div>
  </div>
</form>
